/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModelDto } from '../../models/user-model-dto';

export interface UserControllerUpdateMe$Params {
  name: string;
}

export function userControllerUpdateMe(http: HttpClient, rootUrl: string, params: UserControllerUpdateMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerUpdateMe.PATH, 'patch');
  if (params) {
    rb.query('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserModelDto>;
    })
  );
}

userControllerUpdateMe.PATH = '/user/me';
